import React from 'react';

export const IconSmallEditLegacy: React.FC = (props = {}) => (
    <svg height="24" width="24" fill="none" viewBox="0 0 24 24" {...props}>
        {props.children}
        <path
            d="M19.704 7.554a1 1 0 000-1.414L17.86 4.296a1 1 0 00-1.414 0L6.219 14.523l3.258 3.259L19.704 7.554zM8.074 19.185L4 20l.815-4.073 3.258 3.258z"
            fill="#374050"
            fillRule="evenodd"
        />
    </svg>
);
